import { patchRequest } from '@/core';
import { cargoCarriers } from '@/requests';

export default async function updateCargoCarrierRequest(id, patch) {
	let url = cargoCarriers.getByIdPath(id);
	let response = await patchRequest(url, {}, patch);
	return response;
}